import { render, staticRenderFns } from "./laboratory_banner.vue?vue&type=template&id=c6567a04&scoped=true"
import script from "./laboratory_banner.vue?vue&type=script&lang=js"
export * from "./laboratory_banner.vue?vue&type=script&lang=js"
import style0 from "./laboratory_banner.vue?vue&type=style&index=0&id=c6567a04&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6567a04",
  null
  
)

export default component.exports